import { Dialog } from '@schibsted-svp/react-ui';
import type { Control, UseFormSetValue } from 'react-hook-form';
import type { FormValues } from '../types';
import { ScheduleDialogFormVideo } from '../fields/ScheduleDialogFormVideo';
import { ScheduleDialogFormAudio } from '../fields/ScheduleDialogFormAudio';

import css from './ScheduleDialogForm.module.scss';

type ScheduleDialogFormProps = {
    control: Control<FormValues>;
    isAudioVod: boolean;
    setValue: UseFormSetValue<FormValues>;
};

export function ScheduleDialogForm({ control, isAudioVod, setValue }: ScheduleDialogFormProps) {
    return (
        <Dialog.Section className={css.container}>
            {isAudioVod ? (
                <ScheduleDialogFormAudio control={control} setValue={setValue} />
            ) : (
                <ScheduleDialogFormVideo control={control} />
            )}
        </Dialog.Section>
    );
}
